import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { getDefaultRedirectPath } from "../../../components/ProtectedRoute/ProtectedRoute";

export const StepConfirmation = ({ step, onSuccess }: any) => {
  const [countdown, setCountdown] = useState(5);
  const { session, refreshSession } = useAuth();
  const navigate = useNavigate();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    // Only start timer if session is available and we haven't redirected yet
    if (!session?.user || hasRedirected) return;

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(async () => {
      // Redirect to user-type-specific route
      const redirectPath = getDefaultRedirectPath(
        //@ts-expect-error
        session.user.system_user_type,
        //@ts-expect-error
        session.user.email,
      );
      setHasRedirected(true);
      // Refresh session before navigating so needsOnboarding is re-evaluated
      // with fresh data (e.g. updated terms_conditions_accepted_at), preventing
      // a redirect loop for users who just re-accepted ToS in the wizard.
      await refreshSession();
      navigate(redirectPath, { replace: true });
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [session?.user, hasRedirected]); // Re-run if session becomes available

  return (
    <div className="flex w-full flex-col gap-4 py-8">
      <p className="text-2xl font-semibold">Thank you, few more seconds</p>
      <p>
        We are redirecting you to your profile in{" "}
        <span className="font-medium">{countdown}</span> seconds.
      </p>
    </div>
  );
};
